export default "__VITE_ASSET__4cc1ea0e__"